import React from 'react';
import FlexContainer from '../../../../../components/material-ui/adaptive/FlexContainer';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import useEditJackpot from '../../../../../hooks/site/bonus/useEditJackpot';
import CusInput from '../../../../../components/material-ui/CusInput';
import JackpotsTable from './JackpotsTable';
import { useTranslation } from 'react-i18next';
import SubgroupSave from '../../../../../components/bonus/ui/SubgroupSave';
import { ENUM_BONUS_ID } from '../../../../../enums/MenuItems';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';

export default function Jackpots({ groupId, group }) {
  const { t } = useTranslation();

  const {
    jackTabs,
    activeTab,
    welcomeEnable,
    rate,
    // lockSetting,
    // updateSubgroups,
    currentBonus,
    superUser,
    // changeLockSetting,
    changeField,
    // changeSubgroup,
    changeRate,
    changeEnable,
    onTabChange,
    onSave
  } = useEditJackpot(groupId);

  return (
    <Box display={'flex'} flexDirection={'column'} gap={1}>
      <FlexContainer display={'flex'} justifyContent={'space-between'}>
        <CusCheckbox title="Enable" checked={welcomeEnable} onChange={changeEnable} />

        <Stack display={'flex'} gap={1} flexDirection={'row'}>
          <Tabs value={activeTab} onChange={onTabChange} variant="scrollable" scrollButtons="auto">
            {jackTabs?.map((tabName, indx) => (
              <Tab
                key={indx}
                iconPosition="end"
                value={indx}
                style={{ fontWeight: 600 }}
                label={t(tabName)}
              />
            ))}
          </Tabs>
        </Stack>
      </FlexContainer>
      <Stack width={300}>
        <CusInput
          value={rate}
          type="number"
          inputProps={{ min: 0, max: 100, step: 0.1 }}
          label={'Percentage of deduction from the rate'}
          onChange={(e) => changeRate(e.target.value)}
        />
      </Stack>
      <ShowContainer condition={currentBonus}>
        <JackpotsTable
          currentBonus={currentBonus}
          changeField={changeField}
          superUser={superUser}
        />
        <SubgroupSave
          // lockSetting={lockSetting}
          // updateSubgroups={updateSubgroups}
          id={ENUM_BONUS_ID.jackpots}
          isNodeGroup={!group?.game}
          onSave={onSave}
          // changeSubgroup={changeSubgroup}
          // changeLockSetting={changeLockSetting}
          // showUpdate={!group?.game}
        />
      </ShowContainer>
    </Box>
  );
}
